"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomPopper = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Generate a default search Popper component
 *
 * @param {object} props
 * @returns JSX.Element
 */
var CustomPopper = function CustomPopper(props) {
  var classes = props.classes;
  return /*#__PURE__*/_react.default.createElement(_core.Popper, _extends({}, props, {
    className: classes.root,
    placement: "bottom"
  }));
};
exports.CustomPopper = CustomPopper;
var _default = CustomPopper;
exports.default = _default;